import React from 'react'

// inputs
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'
import AppFormikTextareaInline from 'utlis/helpers/forms/AppFormikTextareaInline';

// html editor
import HTMLEditor from 'utlis/helpers/HTMLEditor'

export default function FormContent(props) {
    const { 
        formik,
        getResult
    } = props

    return (
        <>
            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Status"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"status"} // important: formik value name for the input
            >
                <option disabled value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </AppFormikSelectInline>

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Name"} // placeholder for the input
                formikFieldName={"name"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Ratings"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"rating"} // important: formik value name for the input
            >
                <option disabled value="">Select Ratings</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </AppFormikSelectInline>
            
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Designation"} // label name
                // isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Designation"} // placeholder for the input
                formikFieldName={"designation"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikTextareaInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap"} // class name for main wrapper
                labelName={"Review"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Review"} // placeholder for the input
                textareaRows={"4"} // rows for textarea
                formikFieldName={"review"} // important: formik value name for the input
            />
        </>
    )
}
